import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './OrganizerSuccessPage.css';

const OrganizerSuccessPage = () => {
  const { t } = useTranslation('organizers');
  const navigate = useNavigate();

  const handleBackToOrganizers = () => {
    navigate('/organizers');
  };

  return (
    <div className="success-page-container">
      <div className="success-content">
        <div className="success-icon-wrapper">
<svg xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104" fill="none">
  <g clip-path="url(#clip0_3794_62123)">
    <path d="M52 104C80.7188 104 104 80.7188 104 52C104 23.2812 80.7188 0 52 0C23.2812 0 0 23.2812 0 52C0 80.7188 23.2812 104 52 104Z" fill="#77CC00"/>
    <path d="M103.443 59.6374C100.573 79.1374 86.8806 95.1112 68.6664 101.278L22.2686 54.8721L32.3232 44.8174L43.5256 56.0218L71.6767 27.8707L103.443 59.6374Z" fill="url(#paint0_linear_3794_62123)"/>
    <path d="M81.7314 37.9234L53.5803 66.0765L52 67.6568L43.5256 76.1292L33.4709 66.0765L22.2686 54.8721L32.3232 44.8174L43.5256 56.0218L52 47.5474L71.6767 27.8707L81.7314 37.9234Z" fill="#FFF5F5"/>
  </g>
  <defs>
    <linearGradient id="paint0_linear_3794_62123" x1="41.3704" y1="35.7703" x2="91.5687" y2="85.9685" gradientUnits="userSpaceOnUse">
      <stop stop-color="#288900"/>
      <stop offset="1" stop-color="#288900" stop-opacity="0"/>
    </linearGradient>
    <clipPath id="clip0_3794_62123">
      <rect width="104" height="104" fill="white"/>
    </clipPath>
  </defs>
</svg>
        </div>
        
        <h1 className="success-title">
          {t('organizerCreatedSuccessfully')}
        </h1>
        
        {/* <p className="success-description">
          {t('organizerCreatedDescription')}
        </p> */}
        
        <button 
          onClick={handleBackToOrganizers}
          className="back-to-organizers-btn"
        >
          {t('backToOrganizers')}
        </button>
      </div>
    </div>
  );
};

export default OrganizerSuccessPage;